import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchStudentMe } from "@/api/studentAuth";

export default function StudentProtectedRoute({ children }) {
  const [ok, setOk] = useState(null);

  useEffect(() => {
    fetchStudentMe()
      .then(() => setOk(true))
      .catch(() => setOk(false));
  }, []);

  if (ok === null) return null;
  if (!ok) return <Navigate to="/student-login" replace />;

  return children;
}
